import { Component } from '@angular/core';

@Component({
  selector: 'app-empresa-seg',
  templateUrl: './empresa-seg.component.html',
  styleUrls: ['./empresa-seg.component.scss']
})
export class EmpresaSegComponent {
  user: any;
  idEmpresa: any;

  constructor() {
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.idEmpresa = this.user.id_empresa;
  }
}
